import type { CSSProperties } from "react";

interface SkeletonProps {
	width?: number | string;
	height?: number | string;
	radius?: number | string;
	style?: CSSProperties;
	className?: string;
}

export function Skeleton({ width, height = 16, radius = 6, style, className }: SkeletonProps) {
	return (
		<span
			className={`skeleton${className ? ` ${className}` : ""}`}
			style={{ width, height, borderRadius: radius, display: "inline-block", ...style }}
		/>
	);
}

export function TokenRowSkeleton() {
	return (
		<div className="token-row-skeleton">
			<Skeleton width={36} height={36} radius={18} />
			<div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
				<Skeleton width={80} height={14} />
				<Skeleton width={120} height={12} />
			</div>
			<div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "flex-end" }}>
				<Skeleton width={60} height={14} />
				<Skeleton width={48} height={12} />
			</div>
		</div>
	);
}

export function BalanceSkeleton() {
	return <Skeleton width={64} height={12} />;
}

export function QuoteRouteSkeleton() {
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
			<Skeleton width="100%" height={14} />
			<Skeleton width="75%" height={14} />
			<Skeleton width="50%" height={14} />
		</div>
	);
}

export function AmountSkeleton() {
	return <Skeleton width={120} height={48} radius={8} />;
}
